import { render, staticRenderFns } from "./AfterPayment.vue?vue&type=template&id=3ffbf7a5&scoped=true"
import script from "./AfterPayment.vue?vue&type=script&lang=js"
export * from "./AfterPayment.vue?vue&type=script&lang=js"
import style0 from "./AfterPayment.vue?vue&type=style&index=0&id=3ffbf7a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffbf7a5",
  null
  
)

export default component.exports